import type { ResizableSeparatorOptions } from '@tunasong/ui-lib'
import { useResizableSeparator } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './resizable-separator.module.css'

export interface ResizableSeparatorProps extends ResizableSeparatorOptions {
  className?: string
}

/**
 * The right sidebar's separator, on its panel's left edge (GH #2973, Joni's spec, approved by Brian): a thin hit area
 * centred on the panel's border. The behaviour is ui-lib's `useResizableSeparator`.
 */
export const ResizableSeparator: FC<ResizableSeparatorProps> = props => {
  const { className, ...options } = props
  const separatorProps = useResizableSeparator(options)
  return <div {...separatorProps} className={[styles.separator, className].filter(Boolean).join(' ')} />
}

export default ResizableSeparator
